
export class Weapon{
    private weaponId : string;
    private ammoType : number;

    constructor(weaponId:string, ammoType : number){
        this.weaponId=weaponId;
        this.ammoType=ammoType;
    }

    public getWeaponId():string{
        return this.weaponId;
    }

    public getAmmoType():number{
        return this.ammoType;
    }
}